import React from 'react'
import SidebarItem from '../presentation/SidebarItem.js'

class Sidebar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      allServiceTitles: this.props.allServiceTitles,
      servicesToCompare: this.props.servicesToCompare,
      filtersHidden: this.props.filtersHidden
    }
    this.handleClick = this.handleClick.bind(this);
    this.handleClear = this.handleClear.bind(this);
  }

  handleClear(e) {
    e.preventDefault()
    this.props.clearAllServices()

    this.setState({
      servicesToCompare: []
    })
  }

  toggleFilters() {
    this.setState({
      filtersHidden: !this.state.filtersHidden
    })
  }

  handleClick(e) {
    const service = e.target.value

    let servicesToCompare
    if(this.state.servicesToCompare.includes(service)) {
      servicesToCompare = this.state.servicesToCompare.filter(item => item !== service)
      this.props.updateServices(service, true, false)
    } else {
      servicesToCompare = [...this.state.servicesToCompare, service]
      this.props.updateServices(service, false, false)
    }
    this.setState({
      servicesToCompare: servicesToCompare
    })
  }

  headingText() {
    let servicesCount = this.state.servicesToCompare.length
    return this.props.accessLevel == 'bronze' ? <a className="bronze-compare a--black p-small" href="/purchase/join">Get access to compare</a> : `Comparing ${servicesCount} selected products`
  }

  render() {
    let servicesArray = this.state.allServiceTitles
    return (
      <aside className={`b--black-20 bl br h-100 fl w-100 relative flex-shrink-0 filters-aside ${this.state.filtersHidden ? 'filters-hidden' : ''}`}>
        <nav className="border-box w-100 flex pl3">
          <button onClick={this.toggleFilters.bind(this)} className="b mb0 items-center w-100 flex relative p-small remove-button-style color-black tl">
            {this.headingText()}
            <a href="#" className={`${this.props.accessLevel == 'bronze' ? 'pointer-disabled o-50' : ''} tr a--black small mla fw5 mr4 nowrap clear-all`} onClick={this.handleClear}>Clear all </a>
            <svg onClick={this.props.toggleSidebar} height="25" width="30" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="chevron chevron-active pointer">
              <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
            </svg>
          </button>
          <svg onClick={this.props.toggleSidebar} height="25" width="30" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="chevron chevron-inactive pointer">
            <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
          </svg>
        </nav>
        {servicesArray.map((item, i) => <SidebarItem key={i}
                                                     handleClick={this.handleClick}
                                                     defaultChecked={false}
                                                     checked={this.state.servicesToCompare.includes(item.id)}
                                                     name={item.title}
                                                     brand={item.brand}
                                                     id={item.id}
                                                     accessLevel={this.props.accessLevel} />
                                                    )}
      </aside>
      )
  }

}

export default Sidebar
